'use client';

var BodyFontFamilyNames = /* @__PURE__ */ ((BodyFontFamilyNames2) => {
  BodyFontFamilyNames2["sourceSans"] = "Source Sans 3";
  BodyFontFamilyNames2["notoSerif"] = "Noto Serif";
  BodyFontFamilyNames2["lato"] = "Lato";
  BodyFontFamilyNames2["montserrat"] = "Montserrat";
  BodyFontFamilyNames2["openSans"] = "Open Sans";
  BodyFontFamilyNames2["raleway"] = "Raleway";
  return BodyFontFamilyNames2;
})(BodyFontFamilyNames || {});
var TitleFontFamilyNames = /* @__PURE__ */ ((TitleFontFamilyNames2) => {
  TitleFontFamilyNames2["sourceSans"] = "Source Sans 3";
  TitleFontFamilyNames2["notoSerif"] = "Noto Serif";
  TitleFontFamilyNames2["lato"] = "Lato";
  TitleFontFamilyNames2["montserrat"] = "Montserrat";
  TitleFontFamilyNames2["openSans"] = "Open Sans";
  TitleFontFamilyNames2["raleway"] = "Raleway";
  return TitleFontFamilyNames2;
})(TitleFontFamilyNames || {});
export {
  BodyFontFamilyNames,
  TitleFontFamilyNames
};
